const rccText: string = 'Remotely created checks generally look like checks you would write, but they do not have your signature. They generally post to your bank account in the same way as regular checks you write.';
export default rccText;
